import {
  postTicketChangeStatus,
  postTicketGetList,
  postTicketGetSubordinatesTickets,
} from "Api/Api";
import { put, takeLatest } from "redux-saga/effects";
import { call } from "typed-redux-saga";
import { getType } from "typesafe-actions";
import {
  changeTicketStatusAsync,
  getTicketsAsync,
  openSubordinatesTickets,
} from "./TicketReducer";

function* getTickets(
  action: ReturnType<typeof getTicketsAsync.request>,
): Generator {
  try {
    const ticketsResponse = yield* call(postTicketGetList, {});
    const subordinatesTicketsResponse = yield* call(
      postTicketGetSubordinatesTickets,
    );

    if (
      ticketsResponse.status === 200 &&
      subordinatesTicketsResponse.status === 200
    ) {
      yield put(
        getTicketsAsync.success({
          tickets: ticketsResponse.json.tickets,
          subordinatesTickets: subordinatesTicketsResponse.json.map((e, i) => {
            return {
              ...e,
              isLoading: false,
              isLoaded: false,
              isOpen: false,
              tickets: undefined,
              isDisplayed: i < 15,
              index: i,
            };
          }),
        }),
      );
    } else {
      yield put(getTicketsAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(getTicketsAsync.failure(err));
  }
}
export function* getTicketsSaga() {
  yield takeLatest(getType(getTicketsAsync.request), getTickets);
}

function* getEmployeeTickets(
  action: ReturnType<typeof openSubordinatesTickets.request>,
): Generator {
  try {
    const ticketsResponse = yield* call(postTicketGetList, {
      employeeID: action.payload,
    });

    if (ticketsResponse.status === 200) {
      yield put(openSubordinatesTickets.success(ticketsResponse.json));
    } else {
      yield put(getTicketsAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(getTicketsAsync.failure(err));
  }
}
export function* getEmployeeTicketsSaga() {
  yield takeLatest(
    getType(openSubordinatesTickets.request),
    getEmployeeTickets,
  );
}

function* changeTicketStatus(
  action: ReturnType<typeof changeTicketStatusAsync.request>,
): Generator {
  try {
    const response = yield* call(postTicketChangeStatus, action.payload);
    if (response.status === 200) {
      yield put(changeTicketStatusAsync.success(response.json));
    } else {
      yield put(changeTicketStatusAsync.failure(response.json));
    }
  } catch (err) {
    yield put(changeTicketStatusAsync.failure(err));
  }
}
export function* changeTicketStatusSaga() {
  yield takeLatest(
    getType(changeTicketStatusAsync.request),
    changeTicketStatus,
  );
}
